/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      id
      firstName
      lastName
      company
      company_orgNumber
      email
      phone
      validTo
      active
      LastLogin
      category
      subCategories
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles(
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        company
        company_orgNumber
        email
        phone
        validTo
        active
        LastLogin
        category
        subCategories
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getJobRequest = /* GraphQL */ `
  query GetJobRequest($id: ID!) {
    getJobRequest(id: $id) {
      id
      title
      startDate
      description
      location
      county
      municipality
      id06
      userId
      userMail
      category
      subCategories
      status
      startNow
      jobLength
      company
      createdAt
      jobType
      updatedAt
      jobRequestComments {
        nextToken
      }
    }
  }
`;
export const listJobRequests = /* GraphQL */ `
  query ListJobRequests(
    $filter: ModelJobRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        startDate
        description
        location
        county
        municipality
        id06
        userId
        userMail
        category
        subCategories
        status
        startNow
        jobLength
        company
        createdAt
        jobType
        updatedAt
      }
      nextToken
    }
  }
`;
export const getJobRequestComment = /* GraphQL */ `
  query GetJobRequestComment($id: ID!) {
    getJobRequestComment(id: $id) {
      id
      jobRequestId
      message
      userId
      userFirstName
      userLastName
      userEmail
      userPhone
      userCompany
      status
      createdAt
      updatedAt
      jobRequest {
        id
        title
        startDate
        description
        location
        county
        municipality
        id06
        userId
        userMail
        category
        subCategories
        status
        startNow
        jobLength
        company
        createdAt
        jobType
        updatedAt
      }
    }
  }
`;
export const listJobRequestComments = /* GraphQL */ `
  query ListJobRequestComments(
    $filter: ModelJobRequestCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobRequestComments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        jobRequestId
        message
        userId
        userFirstName
        userLastName
        userEmail
        userPhone
        userCompany
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($id: ID!) {
    getNotification(id: $id) {
      id
      userId
      category
      county
      municipality
      userEmail
      categoryName
      createdAt
      updatedAt
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        category
        county
        municipality
        userEmail
        categoryName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
